module.exports = __webpack_public_path__ + "media/images/equipments-img-04-d9d8900ee6785152ba2aa1ff6ad1aa5f.jpg";